import { Component, computed, ChangeDetectionStrategy } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatListItem } from '@angular/material/list';

import { isDarkTheme, StyleService } from '@vendasta/galaxy/style-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'atlas-theme-switcher',
  imports: [MatIcon, TranslateModule, MatListItem],
  templateUrl: './theme-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './theme-switcher.component.scss',
})
export class ThemeSwitcherComponent {
  currentTheme = toSignal(this.styleService.activeTheme$);

  isDark = computed(() => isDarkTheme(this.currentTheme()));

  icon = computed(() => {
    return this.isDark() ? 'wb_sunny' : 'brightness_2';
  });

  text = computed(() => {
    return this.isDark() ? 'THEME_SWITCHER.SWITCH_TO_LIGHT' : 'THEME_SWITCHER.SWITCH_TO_DARK';
  });

  constructor(private styleService: StyleService) {}

  toggleColorScheme(): void {
    this.styleService.toggleLightDark('business-center-client');
  }
}
